import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ClipboardList, ArrowRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PendingApprovalsAlert = () => {
  const [requests, setRequests] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/approval-requests`, { params: { status: 'pending' } })
      .then(res => setRequests(res.data.requests || []))
      .catch(() => setRequests([]));
  }, []);

  if (requests.length === 0) return null;
  const stores = [...new Set(requests.map(r => r.store_name))].join(', ');

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-4 rounded-lg border border-amber-500/40 bg-amber-500/10" data-testid="dashboard-pending-approvals-alert">
      <div className="flex items-center gap-3">
        <ClipboardList className="h-6 w-6 text-amber-500 shrink-0" />
        <div>
          <p className="font-semibold text-amber-600" data-testid="dashboard-pending-approvals-count">
            {requests.length} Pending Admin Approval Request{requests.length > 1 ? 's' : ''}
          </p>
          <p className="text-sm text-muted-foreground">Sales entries locked awaiting your review: {stores}</p>
        </div>
      </div>
      <Button onClick={() => navigate('/approval-requests')} className="bg-amber-500 hover:bg-amber-600 text-white" data-testid="dashboard-review-approvals-btn">
        Review Requests <ArrowRight className="h-4 w-4 ml-1" />
      </Button>
    </div>
  );
};
